import { render } from "./company-requirements.vue?vue&type=template&id=3487320b&scoped=true&ts=true"
import script from "./company-requirements.vue?vue&type=script&lang=ts"
export * from "./company-requirements.vue?vue&type=script&lang=ts"

import "./company-requirements.vue?vue&type=style&index=0&id=3487320b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3487320b"]])

export default __exports__